import axios, { AxiosError } from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { SearchProfile } from '@/types';
import { GET_SEARCH_PROFILE } from '@/constants';
import { useAuth } from '@/contexts';

export const useGetSearchProfile = (objectId?: string | null) => {
  const queryClient = useQueryClient();
  const { isAuthenticated } = useAuth();

  return useQuery<SearchProfile, AxiosError>({
    queryKey: ['search-profile-object', objectId],
    queryFn: async () => {
      const res = await axios.get<SearchProfile>(`${GET_SEARCH_PROFILE}/${objectId}`);
      void queryClient.invalidateQueries({ queryKey: ['housing-list'] });
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 0,
    gcTime: 0,
    enabled: Boolean(objectId) && isAuthenticated,
  });
};
